const cache = new Map();

class StorageCache {
  constructor(storage) {
    this.storage = storage;
  }

  get(key) {
    return this.storage
      ? JSON.parse(this.storage.getItem(key))
      : cache.get(key);
  }

  set(key, value) {
    if (this.storage) {
      this.storage.setItem(key, JSON.stringify(value));
    } else {
      cache.set(key, value);
    }
  }
}

export default StorageCache;
